import {
    FieldInCard,
} from 'app/types/form.types'

import {
    ContainerLocationChangeNote,
} from '../../../ContainerNotes.types'
import {
    AuditTrailConfig, getChangeConfig,
} from './notesConfigs'

type Fields = keyof ContainerLocationChangeNote

const locationFields: FieldInCard<Fields>[] = [
    getChangeConfig({
        showOrder: true,
        removeAttachmentsField: true,
    }),
    {
        title: 'LOCATION_OLD',
        className: 'locationOld',
        fields: [{
            name: 'locationChange',
            labelKey: 'CONTAINER_LOCATION_CHANGE',
            componentName: 'LocationChangeSelector',
            inputs: ['old'],
        }],
    },
    {
        title: 'LOCATION_NEW',
        className: 'locationNew',
        fields: [{
            name: 'locationChange',
            labelKey: 'CONTAINER_LOCATION_CHANGE',
            componentName: 'LocationChangeSelector',
            inputs: ['actual'],
        }],
    },
    AuditTrailConfig,
]

export default locationFields
